import { render, staticRenderFns } from "./UpdateActionItems.vue?vue&type=template&id=57d348b6&scoped=true&"
import script from "./UpdateActionItems.vue?vue&type=script&lang=ts&"
export * from "./UpdateActionItems.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateActionItems.vue?vue&type=style&index=0&id=57d348b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d348b6",
  null
  
)

export default component.exports